import { Suspense, lazy } from "react";
import { useRoutes, Routes, Route, Navigate } from "react-router-dom";
import routes from "tempo-routes";
import { AuthProvider } from "./lib/authContext";

const Home = lazy(() => import("./components/home"));
const LandingPage = lazy(() => import("./components/LandingPage"));

function LoadingSpinner() {
  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full mx-auto"></div>
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  // Handle Tempo routes
  const tempoRoutes =
    import.meta.env.VITE_TEMPO === "true" ? useRoutes(routes) : null;

  return (
    <AuthProvider>
      <Suspense fallback={<LoadingSpinner />}>
        {tempoRoutes}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/scraper" element={<Home />} />
          <Route path="/app" element={<Navigate to="/scraper" />} />
          {/* Add this before any catchall routes */}
          {import.meta.env.VITE_TEMPO === "true" && (
            <Route path="/tempobook/*" />
          )}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;
